import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { RiErrorWarningLine } from "react-icons/ri";

const TRANSLATIONS = {
  EN: {
    deleteBtn: "Delete",
    title: "Delete User",
    areYouSure: "Are you sure?",
    about: "You are about to delete",
    cannotUndo: ". This action cannot be undone.",
    cancel: "Cancel",
  },
  ES: {
    deleteBtn: "Eliminar",
    title: "Eliminar Usuario",
    areYouSure: "¿Estás seguro?",
    about: "Estás a punto de eliminar",
    cannotUndo: ". Esta acción no se puede deshacer.",
    cancel: "Cancelar",
  },
};

const DeleteModal = ({
  handleDelete,
  content = "this item",
  deleting,
  onOpen,
  lang = "EN",
  buttonClassName = "",
  isOpen: controlledIsOpen,
  onClose,
}) => {
  const [internalIsModalOpen, setInternalIsModalOpen] = useState(false);
  const isControlled = controlledIsOpen !== undefined;
  const isModalOpen = isControlled ? controlledIsOpen : internalIsModalOpen;
  const t = TRANSLATIONS[lang] || TRANSLATIONS.EN;

  const openModal = () => {
    if (onOpen) onOpen();
    if (!isControlled) setInternalIsModalOpen(true);
  };
  const closeModal = () => {
    if (!isControlled) setInternalIsModalOpen(false);
    if (isControlled && onClose) onClose();
  };

  return (
    <div className={buttonClassName ? "w-full" : ""}>
      {/* <button
        type="button"
        onClick={openModal}
        className={buttonClassName || "px-3 py-1.5 rounded-lg text-xs font-roboto font-semibold text-red-500 border border-red-200 hover:bg-red-500 hover:text-white transition-all uppercase tracking-wide"}
      >
        {t.deleteBtn}
      </button> */}

      {isModalOpen && (
        <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50 p-4 cursor-default" onClick={closeModal}>
          <div className="bg-white rounded-2xl shadow-box max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center border-b border-gray px-6 py-4">
              <h2 className="font-roboto font-bold text-lg text-red-500 uppercase tracking-wide">
                {t.title}
              </h2>
              <button
                className="text-gray-400 hover:text-gray-600 transition-colors"
                onClick={closeModal}
              >
                <IoMdClose className="text-xl" />
              </button>
            </div>

            <div className="p-6 flex flex-col items-center gap-3 text-center">
              <RiErrorWarningLine className="text-5xl text-red-500" />
              <h3 className="font-roboto font-bold text-lg text-gray-800">{t.areYouSure}</h3>
              <p className="font-roboto text-sm text-gray-500">
                {t.about}{" "}
                <span className="font-semibold text-gray-700">{content}</span>{t.cannotUndo}
              </p>
            </div>

            <div className="flex justify-end gap-3 px-6 pb-6">
              <button
                className="px-5 py-2.5 rounded-lg font-roboto font-semibold text-sm text-gray-600 border border-gray hover:bg-gray transition-all"
                onClick={closeModal}
              >
                {t.cancel}
              </button>
              <button
                onClick={() => handleDelete(closeModal)}
                className="px-5 py-2.5 rounded-lg font-roboto font-bold text-sm text-white bg-red-500 hover:bg-red-600 transition-all uppercase tracking-wide"
              >
                {deleting ? (
                  <div className="loader flex justify-center items-center mx-5" />
                ) : (
                  t.deleteBtn
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteModal;
